import Services from './base-services'

const service = new Services('ranking')

export default {
    getRankings(schoolId: any) {
        return service.get(`getRankings?schoolId=${schoolId}&page=0&size=15`)
    },
}
